// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Request from './helper/request'
import _ from 'lodash'
import { routerHistory, writeHistory } from 'vue-router-back-button';
import config from '../config/index';
import 'es6-promise/auto';

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min';

import '@fortawesome/fontawesome-free/js/all.min'

const request = new Request(false, config);

const VueRequest = {
  install(Vue, options) {
    Vue.mixin({});
    Vue.prototype.$request = function() {
      return request;
    }
  }
};

const lodash = {
  install(Vue, options) {
    Vue.mixin({});
    Vue.prototype.$_ = function() {
      return _;
    }
  }
};

const auth = {
  loggedIn() {
    return (localStorage.getItem('passphrase') !== null && localStorage.getItem("token") !== null)
  },
  logout() {
    UIkit.notification.closeAll();

    request.post('/user/sign_out', {
      passphrase_id: localStorage.getItem('passphrase_id'),
    }).then(r => {
      localStorage.removeItem('passphrase_id');
      localStorage.removeItem('passphrase');
      localStorage.removeItem('user_id');
      localStorage.removeItem('token');
      request.passphrase = null;
      request.token = null;

      router.push({name: 'Login'})
    });
  }
};

const VueAuth = {
  install(Vue, options) {
    Vue.mixin({});
    Vue.prototype.$auth = function() {
      return auth;
    };
  }
};

Vue.use(VueRequest);
Vue.use(lodash);
Vue.use(routerHistory);
Vue.use(VueAuth);
UIkit.use(Icons);

const VueUIkit = {
  install(Vue, options) {
    Vue.mixin({});
    Vue.prototype.$uikit = function() {
      return UIkit;
    }
  }
}

Vue.use(VueUIkit);

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.loggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
});

router.afterEach(writeHistory);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js